module.exports = __webpack_public_path__ + "static/img/logo.bd945213.png";